import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20crimson%20and%20golden%20tones%2C%20subtle%20geometric%20patterns%2C%20elegant%20and%20minimalist%20design%2C%20smooth%20flowing%20textures%2C%20luxurious%20feel%2C%20no%20text%20no%20people%20no%20objects&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="w-full h-full object-cover absolute inset-0"
      />
      <div className="absolute inset-0 bg-black/45"></div>
      <div className="relative z-10 max-w-[1280px] mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-bold text-white mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
          即刻开启国产在线视听之旅
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-6 max-w-xl mx-auto leading-relaxed">
          无需下载，无需注册，免费在线观看海量优质国产内容。覆盖多元题材，持续更新。
        </p>
        <Link
          to="/category/guochan-ju"
          className="inline-flex px-8 py-3 bg-accent-500 text-white font-medium rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
        >
          立即免费访问
        </Link>
      </div>
    </section>
  );
}